<template>
    <div>
        <br><br><br>
        
        <div class='row'>
            <div class='my-3 col-md-4 offset-md-4 col-xs-12 alert alert-success' v-show='success'>A password reset link has been sent to your email</div>
            <div class='my-3 col-md-4 offset-md-4 col-xs-12 alert alert-danger' v-show='error'>Please enter a valid email</div>
            <input type='text' class='form-control my-3 col-md-4 offset-md-4 col-xs-12' v-model='email' placeholder='Enter your email'/>
            <div class='col-md-4 offset-md-4 col-xs-12 my-3'>
                <button class='btn btn-primary' v-show='!success' v-on:click='send'>Reset</button>
            </div>
        </div>
    </div>
</template>

<script>
import http from "../commons/http.js";

export default {
    data:function(){
        return{
            email:'',
            success:false,
            error:false,
            errMsg:''
        }
    },
    methods:{
        send: async function(){
            
            this.error = false;
            this.success = false;

            try{
                await http.post('/reset/send', {email:this.email});
                this.success = true;
            }catch(err){
                console.error('reset email err', err);
                this.error = true;
            }
        }
    }
}
</script>

<style>

</style>
